import { render } from "./TopBar.vue?vue&type=template&id=65b04c37&scoped=true&ts=true"
import script from "./TopBar.vue?vue&type=script&lang=ts"
export * from "./TopBar.vue?vue&type=script&lang=ts"

import "./TopBar.vue?vue&type=style&index=0&id=65b04c37&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b04c37"]])

export default __exports__